import { render, staticRenderFns } from "./AuditoriaMolexEventos.vue?vue&type=template&id=50333bbd&scoped=true"
import script from "./AuditoriaMolexEventos.vue?vue&type=script&lang=js"
export * from "./AuditoriaMolexEventos.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaMolexEventos.vue?vue&type=style&index=0&id=50333bbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50333bbd",
  null
  
)

export default component.exports